import { Observable } from 'rxjs';
import { AuthResponse } from './auth-response';

export interface AuthService {
  initialise(): Observable<AuthResponse>;
  login(requirePassword: boolean): Observable<{ network, authResponse: AuthResponse }>;
  logout(): Observable<{ network: string }>;
}
